<template>
    <Bar :data="data" :options="options" />
</template>

<script>
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
import { Bar } from "vue-chartjs";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default {
    name: "CharBarElement",
    components: {
        Bar,
    },
    props: {
        bookingdata: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fullMonthLabels: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
            ],
            data: {
                labels: [],
                datasets: [
                    {
                        label: "Reservas",
                        backgroundColor: "#346cf0ff",
                        data: [],
                        barPercentage: 0.8,
                        categoryPercentage: 1.0,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        suggestedMax: 10,
                    },
                },
            },
        };
    },
    created() {
        const monthMap = {
            Jan: "Janeiro",
            Fev: "Fevereiro",
            Mar: "Março",
            Abr: "Abril",
            Mai: "Maio",
            Jun: "Junho",
            Jul: "Julho",
            Ago: "Agosto",
            Set: "Setembro",
            Out: "Outubro",
            Nov: "Novembro",
            Dez: "Dezembro",
        };

        const values = this.fullMonthLabels.map((abbreviation) => {
            const full = monthMap[abbreviation];
            return this.bookingdata[full] || 0;
        });

        const max = Math.max(...values);

        this.data.labels = this.fullMonthLabels;
        this.data.datasets[0].data = values;
        this.options.scales.y.suggestedMax = max * 1.1;
    },
};
</script>
